import { useEffect, useMemo, useState } from "react";

export const SearchableList = ({
  items,
  selectedIds,
  onSelect,
  onSearch,
  onSelectAll,
  disabled,
  renderLabel,
  placeholder,
  renderTopSelection,
}) => {
  const [search, setSearch] = useState("");

  const filteredItems = useMemo(() => {
    if (!search.trim()) return items;

    const value = search.toLowerCase();

    return items.filter((item) =>
      renderLabel(item).toLowerCase().includes(value),
    );
  }, [items, search, renderLabel]);

  const allSelected =
    filteredItems.length > 0 &&
    filteredItems.every((item) => selectedIds.includes(item.id));

  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch?.(search);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [search]);

  return (
    <>
      {/* 🔍 Search */}
      <div className="px-3">
        <input
          type="text"
          className="search-input form-control"
          placeholder={placeholder}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>

      {renderTopSelection && renderTopSelection()}

      {/* ✅ Select All (Search ke baad) */}
      <div
        className="sub-school-checkbox-item select-all"
        onClick={() => onSelectAll(filteredItems)}
      >
        <input
          type="checkbox"
          checked={allSelected}
          onChange={() => onSelectAll(filteredItems)}
          disabled={disabled}
        />
        <span>Selected ({selectedIds.length})</span>
      </div>

      {/* 📋 List */}
      {filteredItems.map((item) => (
        <div
          key={item.id}
          className="sub-school-checkbox-item"
          onClick={() => onSelect(item.id)}
        >
          <input
            type="checkbox"
            checked={selectedIds.includes(item.id)}
            onChange={() => onSelect(item.id)}
            disabled={disabled}
          />
          <span>{renderLabel(item)}</span>
        </div>
      ))}

      {filteredItems.length === 0 && (
        <div className="scroll-end">No results found</div>
      )}
    </>
  );
};
